/* eslint-disable */

import Dashboard from 'common/Dashboard';
import LoginForm from 'login/LoginForm';
import SsoRedirect from 'login/SsoRedirect';
import SsoCallback from 'login/SsoCallback';
import SsoConsentResult from 'login/SsoConsentResult';
import PasswordReset from 'login/PasswordReset';
import PasswordChange from 'login/PasswordChange';

import PaymentMainView from 'payment/index';
import PaymentRegistrationResult from 'payment/features/RegistrationResult';

import ProductsMainView from 'products/MainView';
import ProductsTopbar from 'products/Topbar';
import ProductsSidebar from 'products/Sidebar';
import AddProductView from 'products/AddProductView';
import ExportProductsForm from 'products/ExportProductsForm';
import ConferenceReportView from 'products/ConferenceReportView';
import ConferenceReportsForm from 'products/ConferenceReportsForm';

import TenantsMainView from 'tenants/MainView';
import TenantsTopbar from 'tenants/Topbar';
import TenantsSidebar from 'tenants/Sidebar';
import AddTenantView from 'tenants/AddTenantView';
import AddKioskView from 'tenants/AddKioskView';
import ExportTenantsForm from 'tenants/ExportTenantsForm';

import KiosksMainView from 'kiosks/MainView';
import KiosksTopbar from 'kiosks/Topbar';
import KiosksSidebar from 'kiosks/Sidebar';

import PermitsMainView from 'permits/MainView';
import PermitsTopbar from 'permits/Topbar';
import PermitsSidebar from 'permits/Sidebar';
import AddPermitView from 'permits/AddPermitView';

import AccountsMainView from 'accounts/MainView';
import AccountsSidebar from 'accounts/Sidebar';
import AccountsTopbar from 'accounts/Topbar';
import AddAccountView from 'accounts/AddAccountView';

import ParkingsMainView from 'parkings/MainView';
import ParkingsSidebar from 'parkings/Sidebar';
import ParkingsTopbar from 'parkings/Topbar';
import AddParkingView from 'parkings/AddParkingView';
import ExportParkingsForm from 'parkings/ExportParkingsForm';
import ReportParkingsForm from 'parkings/ReportParkingsForm';
import ConferenceParkingView from 'parkings/ConferenceParkingView';
import ParkingSessionView from 'parkings/ParkingSessionView';

import EndUserMainView from 'end_user/MainView';
import EditEndUserProfile from 'end_user/EditProfile';
import EditPermit from 'end_user/EditPermit';

import ComponentsOverview from 'common/ComponentsOverview';

import AddPricingRuleView from 'pricingrules/AddPricingRuleView';
import AddConferenceRuleView from 'conferencerules/AddConferenceRuleView';

import LandlordsMainView from 'landlords/MainView';
import LandlordsTopbar from 'landlords/Topbar';
import LandlordsSidebar from 'landlords/Sidebar';
import AddLandlordView from 'landlords/AddLandlordView';

import ZonesMainView from 'zones/MainView';
import ZonesTopbar from 'zones/Topbar';
import ZonesSidebar from 'zones/Sidebar';
import AddZoneView from 'zones/AddZoneView';

import MapsMainView from 'maps/MainView';
import MapsTopbar from 'maps/Topbar';
import MapsSidebar from 'maps/Sidebar';

import UsersMainView from 'users/MainView';
import UsersTopbar from 'users/Topbar';
import UsersSidebar from 'users/Sidebar';
import AddUserView from 'users/AddUserView';
import ExportUsersForm from 'users/ExportUsersForm';
import ImportUsersForm from 'users/ImportUsersForm';

import BlacklistMainView from 'blacklist/MainView';
import BlacklistSidebar from 'blacklist/Sidebar';
import BlacklistTopbar from 'blacklist/Topbar';
import AddBlacklistView from 'blacklist/AddBlacklistView';

import Audit from 'audit';
/* eslint-enable */

const site_title = process.env.TITLE;

// checking permission depending on user role.
let isPermitted = (roleName) => {
  return JSON.parse(localStorage.getItem('user')).selectedRole.role === roleName
}

// export/report pages are only for partner-level roles (landlord, tenant) and
// superadmin; the backend rejects role 'user' on these endpoints.
let partnerRoleGuard = (to, from, next) => {
  let selectedRole = null;
  try {
    selectedRole = JSON.parse(localStorage.getItem('user')).selectedRole;
  } catch (e) {
    selectedRole = null;
  }
  if (selectedRole
    && (selectedRole.role === 'landlord' || selectedRole.role === 'tenant' || selectedRole.isSuperadmin)) {
    next(true);
  } else {
    next('/');
  }
};

// kiosk management is landlord/superadmin only (matches the backend and the nav).
let landlordGuard = (to, from, next) => {
  let selectedRole = null;
  try {
    selectedRole = JSON.parse(localStorage.getItem('user')).selectedRole;
  } catch (e) {
    selectedRole = null;
  }
  if (selectedRole && (selectedRole.role === 'landlord' || selectedRole.isSuperadmin)) {
    next(true);
  } else {
    next('/');
  }
};

export default [
  { name: 'dashboard',
    path: '/',
    component: Dashboard,
    meta: {
      title: site_title + ' | Dashboard',
    },
  },
  {
    name: 'payment',
    path: '/payment',
    meta: {
      title: site_title + ' | Payment',
      onMobileScreen: {
        show_sidebar: true,
        show_mainview: true,
      },
    },
    component: PaymentMainView,
    beforeEnter: (to, from, next) => {
      if(isPermitted('user')) {
        next(true);
      } else {
        next('/');
      }
    }
  },
  {
    name: 'payment_registration_result',
    path: '/payment/register/result',
    meta: {
      title: site_title + ' | Card Registration Result',
      onMobileScreen: {
        show_sidebar: true,
        show_mainview: true,
      },
    },
    component: PaymentRegistrationResult,
    beforeEnter: (to, from, next) => {
      if(isPermitted('user')) {
        next(true);
      } else {
        next('/');
      }
    }
  },
  { name: 'parkingSession',
    path: '/parking/session/:sessionId',
    component: ParkingSessionView,
    meta: {
    title: site_title + ' | Parking Session',
      noAuth: true,
    },
  },
  { name: 'login',
    path: '/login',
    component: LoginForm,
    meta: {
      title: site_title + ' | Login',
      noAuth: true,
    },
  },
  { name: 'ssoCallback',
    path: '/sso/callback',
    component: SsoCallback,
    meta: {
      title: site_title + ' | SSO',
      noAuth: true,
    },
  },
  { name: 'ssoConsentResult',
    path: '/sso/consent-result',
    component: SsoConsentResult,
    meta: {
      title: site_title + ' | SSO',
      noAuth: true,
    },
  },
  { name: 'ssoRedirect',
    path: '/sso/:key',
    component: SsoRedirect,
    meta: {
      title: site_title + ' | SSO',
      noAuth: true,
    },
  },
  {
    name: 'reset',
    path: '/reset',
    component: PasswordReset,
    meta: {
      title: site_title + ' | Password Reset',
      noAuth: true,
    },
  },
  {
    name: 'password-reset',
    path: '/password/reset/:token/:email',
    component: PasswordChange,
    meta: {
      title: site_title + ' | Password Change',
      noAuth: true,
    },
  },
  { name: 'products',
    path: '/products',
    meta: {
      title: site_title + ' | Products',
      onMobileScreen: {
        show_sidebar: true,
        show_mainview: false,
      },
    },
    components: {
      default: ProductsMainView,
      topbar: ProductsTopbar,
      sidebar: ProductsSidebar,
    },
    children: [
      { name: 'add-product',
        path: 'add',
        meta: {
          title: site_title + ' | Add products',
          onMobileScreen: {
            show_sidebar: false,
            show_mainview: true,
          },
        },
      },
      { name: 'product',
        path: ':id',
        meta: {
          title: site_title + ' | Products',
          onMobileScreen: {
            show_sidebar: false,
            show_mainview: true,
          },
        },
        children: [
          { name: 'edit-product',
            path: 'edit',
            meta: {
              title: site_title + ' | Edit Product',
              onMobileScreen: {
                show_sidebar: false,
                show_mainview: true,
              },
            },
          },
        ],
      },
    ],
  },
  { name: 'tenants',
    meta: {
      title: site_title + ' | Tenants',
      onMobileScreen: {
        show_sidebar: true,
        show_mainview: false,
      },
    },
    path: '/tenants',
    components: {
      default: TenantsMainView,
      topbar: TenantsTopbar,
      sidebar: TenantsSidebar,
    },
    children: [
      { name: 'add-tenant',
        path: 'add',
        meta: {
          title: site_title + ' | Add Tenant',
          onMobileScreen: {
            show_sidebar: false,
            show_mainview: true,
          },
        },
      },
      { name: 'tenant',
        path: ':id',
        meta: {
          title: site_title + ' | Tenants',
          onMobileScreen: {
            show_sidebar: false,
            show_mainview: true,
          },
        },
        children: [
          { name: 'edit-tenant',
            path: 'edit',
            meta: {
              title: site_title + ' | Edit',
              onMobileScreen: {
                show_sidebar: false,
                show_mainview: true,
              },
            },
          },
          {
            name: 'export-tenants-details',
            path: 'export',
            meta: {
              title: site_title + ' | Export',
              onMobileScreen: {
                show_sidebar: false,
                show_mainview: true,
              },
            },
          }
        ],
      },
    ],
  },
  { name: 'kiosks',
    path: '/kiosks',
    beforeEnter: landlordGuard,
    meta: {
      title: site_title + ' | Kiosks',
      onMobileScreen: {
        show_sidebar: true,
        show_mainview: false,
      },
    },
    components: {
      default: KiosksMainView,
      topbar: KiosksTopbar,
      sidebar: KiosksSidebar,
    },
    children: [
      { name: 'add-kiosk',
        path: 'add',
        meta: {
          title: site_title + ' | Add Kiosk',
          onMobileScreen: {
            show_sidebar: false,
            show_mainview: true,
          },
        },
      },
      { name: 'kiosk',
        path: ':id',
        meta: {
          title: site_title + ' | Kiosk',
          onMobileScreen: {
            show_sidebar: false,
            show_mainview: true,
          },
        },
      },
      { name: 'edit-kiosk',
        path: ':id/edit',
        meta: {
          title: site_title + ' | Edit Kiosk',
          onMobileScreen: {
            show_sidebar: false,
            show_mainview: true,
          },
        },
      },
    ],
  },
  { name: 'permits',
    path: '/permits',
    meta: {
      title: site_title + ' | Permits',
      onMobileScreen: {
        show_sidebar: true,
        show_mainview: false,
      },
    },
    components: {
      default: PermitsMainView,
      topbar: PermitsTopbar,
      sidebar: PermitsSidebar,
    },
    children: [
      { name: 'add-permit',
        meta: {
          title: site_title + ' | Add Permit',
          onMobileScreen: {
            show_sidebar: false,
            show_mainview: true,
          },
        },
        path: 'add',
        components: {
          default: AddPermitView,
        },
        children: [
          { name: 'add-permit-to-user',
            path: 'user/:userId',
            meta: {
              title: site_title + ' | Add Permit',
              onMobileScreen: {
                show_sidebar: false,
                show_mainview: true,
              },
            },
          },
        ],
      },
      { name: 'permit',
        path: ':id',
        meta: {
          title: site_title + ' | Permit',
          onMobileScreen: {
            show_sidebar: false,
            show_mainview: true,
          },
        },
        children: [
          { name: 'edit-permit',
            path: 'edit',
            meta: {
              title: site_title + ' | Edit Permit',
              onMobileScreen: {
                show_sidebar: false,
                show_mainview: true,
              },
            },
            components: {
              default: AddPermitView,
            },
          },
        ],
      },
    ],
  },
  { name: 'export-parking',
    meta: {
      title: site_title + ' | Edit',
    },
    path: '/parkings/export',
    component: ExportParkingsForm,
    beforeEnter: partnerRoleGuard,
  },
  { name: 'report-parking',
    meta: {
      title: site_title + ' | Report',
    },
    path: '/report',
    component: ReportParkingsForm,
    beforeEnter: partnerRoleGuard,
  },
  { name: 'export-products',
    meta: {
      title: site_title + ' | Edit',
    },
    path: '/products/export',
    component: ExportProductsForm,
    beforeEnter: partnerRoleGuard,
  },
  { name: 'report-conference-products',
    meta: {
      title: site_title + ' | Conference Report',
    },
    path: '/products/conferencereport',
    component: ConferenceReportsForm,
  },
  { name: 'report-conference-product',
    meta: {
      title: site_title + ' | Edit',
    },
    path: '/products/conferencereport/:id',
    component: ConferenceReportView,
  },
  { name: 'export-tenants',
    meta: {
      title: site_title + ' | Edit',
    },
    path: '/tenants/export',
    component: ExportTenantsForm,
    beforeEnter: partnerRoleGuard,
  },
  { name: 'export-users',
    meta: {
      title: site_title + ' | Edit',
    },
    path: '/users/export',
    component: ExportUsersForm,
    beforeEnter: partnerRoleGuard,
  },
  { name: 'import-users',
    path: '/users/import',
    meta: {
      title: site_title + ' | Import',
    },
    component: ImportUsersForm,
      },
  { name: 'parkings',
    path: '/parkings',
    meta: {
      title: site_title + ' | Parkings',
      onMobileScreen: {
        show_sidebar: true,
        show_mainview: false,
      },
    },
    components: {
      default: ParkingsMainView,
      topbar: ParkingsTopbar,
      sidebar: ParkingsSidebar,
    },
    children: [
      { name: 'add-parking',
        path: 'add',
        meta: {
          title: site_title + ' | Add parking',
          onMobileScreen: {
            show_sidebar: false,
            show_mainview: true,
          },
        },
      },
      { name: 'parking',
        path: ':id',
        meta: {
          title: site_title + ' | Parking',
          onMobileScreen: {
            show_sidebar: false,
            show_mainview: true,
          },
        },
        children: [
          { name: 'edit-parking',
            path: 'edit',
            meta: {
              title: site_title + ' | Edit parking',
              onMobileScreen: {
                show_sidebar: false,
                show_mainview: true,
              },
            },
          },
        ],
      },
    ],
  },
  { name: 'accounts',
    path: '/accounts',
    meta: {
      title: site_title + ' | Accounts',
    },
    components: {
      default: AccountsMainView,
      topbar: AccountsTopbar,
      sidebar: AccountsSidebar,
    },
    children: [
      { name: 'account',
        path: ':id',
        meta: {
          title: site_title + ' | Account',
        },
      },
    ],
  },
  { name: 'add-account',
    path: '/accounts/add',
    meta: {
      title: site_title + ' | Add Account',
    },
    components: {
      default: AddAccountView,
      topbar: AccountsTopbar,
      sidebar: AccountsSidebar,
    },
    children: [
      { name: 'edit-account',
        path: ':id',
        meta: {
          title: site_title + ' | Edit',
        },
      },
    ],
  },

  { name: 'user-permits',
    meta: {
      title: site_title + ' | Dashboard',
    },
    path: '/user-permit/',
    component: EndUserMainView,
    children: [
      { name: 'user-permit',
        path: ':id',
        meta: {
          title: site_title + ' | Dashboard',
        },
      },
    ],
  },

  { name: 'edit-pricingrule',
    path: '/products/:id/pricingrules/:ruleId/edit',
    meta: {
      title: site_title + ' | Edit Pricing Rule',
    },
    components: {
      default: AddPricingRuleView,
    },
  },
  { name: 'add-pricingrule',
    path: '/products/:id/pricingrules/add',
    meta: {
      title: site_title + ' | Add Pricing Rule',
    },
    components: {
      default: AddPricingRuleView,
    },
  },
  { name: 'edit-conferencerule',
    path: '/products/:id/conferencerules/:ruleId/edit',
    meta: {
      title: site_title + ' | Edit Conference Rule',
    },
    components: {
      default: AddConferenceRuleView,
    },
  },
  { name: 'add-conferencerule',
    path: '/products/:id/conferencerules/:ruleType/add',
    meta: {
      title: site_title + ' | Add Conference Rule',
    },
    components: {
      default: AddConferenceRuleView,
    },
  },
  { name: 'landlords',
    meta: {
      title: site_title + ' | Landlords',
      onMobileScreen: {
        show_sidebar: true,
        show_mainview: false,
      },
    },
    path: '/landlords',
    components: {
      default: LandlordsMainView,
      topbar: LandlordsTopbar,
      sidebar: LandlordsSidebar,
    },
    children: [
      { name: 'add-landlord',
        path: 'add',
        meta: {
          title: site_title + ' | Add Landlord',
          onMobileScreen: {
            show_sidebar: false,
            show_mainview: true,
          },
        },
      },
      { name: 'landlord',
        path: ':id',
        meta: {
          title: site_title + ' | Landlords',
          onMobileScreen: {
            show_sidebar: false,
            show_mainview: true,
          },
        },
        children: [
          { name: 'edit-landlord',
            path: 'edit',
            meta: {
              title: site_title + ' | Edit',
              onMobileScreen: {
                show_sidebar: false,
                show_mainview: true,
              },
            },
          },
        ],
      },
    ],
  },
  { name: 'zones',
    meta: {
      title: site_title + ' | Zones',
      onMobileScreen: {
        show_sidebar: true,
        show_mainview: false,
      },
    },
    path: '/zones',
    components: {
      default: ZonesMainView,
      topbar: ZonesTopbar,
      sidebar: ZonesSidebar,
    },
    children: [
      { name: 'add-zone',
        path: 'add',
        meta: {
          title: site_title + ' | Add Zone',
          onMobileScreen: {
            show_sidebar: false,
            show_mainview: true,
          },
        },
      },
      { name: 'zone',
        path: ':id',
        meta: {
          title: site_title + ' | Zones',
          onMobileScreen: {
            show_sidebar: false,
            show_mainview: true,
          },
        },
        children: [
          { name: 'edit-zone',
            path: 'edit',
            meta: {
              title: site_title + ' | Edit',
              onMobileScreen: {
                show_sidebar: false,
                show_mainview: true,
              },
            },
          },
        ],
      },
    ],
  },
  { name: 'maps',
    meta: {
      title: site_title + ' | Maps',
      onMobileScreen: {
        show_sidebar: true,
        show_mainview: false,
      },
    },
    path: '/maps',
    components: {
      default: MapsMainView,
      topbar: MapsTopbar,
      sidebar: MapsSidebar,
    },
    children: [
      { name: 'add-map',
        path: 'add',
        meta: {
          title: site_title + ' | Add Map',
          onMobileScreen: {
            show_sidebar: false,
            show_mainview: true,
          },
        },
      },
      { name: 'map',
        path: ':id',
        meta: {
          title: site_title + ' | Map',
          onMobileScreen: {
            show_sidebar: false,
            show_mainview: true,
          },
        },
      }
     ]
  },
  { name: 'users',
    meta: {
      title: site_title + ' | Users',
      onMobileScreen: {
        show_sidebar: true,
        show_mainview: false,
      },
    },
    path: '/users',
    components: {
      default: UsersMainView,
      topbar: UsersTopbar,
      sidebar: UsersSidebar,
    },
    children: [
      { name: 'add-user',
        path: 'add',
        meta: {
          title: site_title + ' | Add User',
          onMobileScreen: {
            show_sidebar: false,
            show_mainview: true,
          },
        },
        components: {
          default: AddUserView,
        },
      },
      { name: 'user',
        path: ':id',
        meta: {
          title: site_title + ' | User',
          onMobileScreen: {
            show_sidebar: false,
            show_mainview: true,
          },
        },
        children: [
          { name: 'edit-user',
            path: 'edit',
            meta: {
              title: site_title + ' | Edit user',
              onMobileScreen: {
                show_sidebar: false,
                show_mainview: true,
              },
            },
          },
          { name: 'add-user-with-permit',
            path: 'permit/add',
            meta: {
              title: site_title + ' | Add Permit',
              onMobileScreen: {
                show_sidebar: false,
                show_mainview: true,
              },
            },
          },
          { name: 'user-with-permit',
            path: 'permit/:permitId',
            meta: {
              title: site_title + ' | User',
              onMobileScreen: {
                show_sidebar: false,
                show_mainview: true,
              },
            },
          },
        ],
      },
    ],
  },
  { name: 'edit-profile',
    meta: {
      title: site_title + ' | Edit',
    },
    path: '/profile/edit',
    component: EditEndUserProfile,
  },
  { name: 'edit-user-permit',
    meta: {
      title: site_title + ' | Edit',
    },
    path: '/permit/:id/edit',
    component: EditPermit,
  },
  { name: 'blacklists',
    meta: {
      title: site_title + ' | Blacklist',
      onMobileScreen: {
        show_sidebar: true,
        show_mainview: false,
      },
    },
    path: '/blacklist',
    components: {
      default: BlacklistMainView,
      topbar: BlacklistTopbar,
      sidebar: BlacklistSidebar,
    },
    children: [
      { name: 'add-blacklist',
        path: 'add',
        meta: {
          title: site_title + ' | Add Blacklist',
          onMobileScreen: {
            show_sidebar: false,
            show_mainview: true,
          },
        },
      },
      { name: 'blacklist',
        path: ':id',
        meta: {
          title: site_title + ' | Blacklist',
          onMobileScreen: {
            show_sidebar: false,
            show_mainview: true,
          },
        },
        children: [
          { name: 'edit-blacklist',
            path: 'edit',
            meta: {
              title: site_title + ' | Edit Blacklist',
              onMobileScreen: {
                show_sidebar: false,
                show_mainview: true,
              },
            },
          },
        ],
      },
    ],
  },
  {
    name: 'audit',
    meta: {
      title: site_title + ' | Audit',
      onMobileScreen: {
        show_sidebar: true,
        show_mainview: false,
      },
    },
    path: '/audit',
    components: {
      default: Audit,
    },
  },
  {
    name: 'conference-parking',
    component: ConferenceParkingView,
    meta: {
      title: site_title + ' | Conference',
    },
    path: '/conference/:url'
  }
];



// WEBPACK FOOTER //
// ./src/routes.js